export default "__VITE_ASSET__B54$z3Ey__"